import { render, staticRenderFns } from "./AddRuleForm.vue?vue&type=template&id=4f7544d6&"
import script from "./AddRuleForm.vue?vue&type=script&lang=js&"
export * from "./AddRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports